<template>
  <button type="button" :class="'ql-' + type"></button>
</template>

<script>
export default {
  props: {
    type: String,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Button.vue?c753bb06
 **/